import styled from '@emotion/styled';

import { Button, tokens } from '@hotjar/hotsauce';
import { useNavigation } from '@hotjar/navigation/src/hooks/useNavigation';
import { useTranslation } from '@hotjar/translations';
import { BILLING } from '@hotjar/webapp/constants/routes/settings';

const CTAWrapper = styled.div`
  display: block;
  margin-top: ${tokens.spacer.x1};
`;

interface UpgradeToUnlockProps {
  siteName: string | null;
  integrationName: string;
}

export const UpgradeToUnlock = ({
  siteName,
  integrationName,
}: UpgradeToUnlockProps): JSX.Element => {
  const { buildHrefFromRoute } = useNavigation();
  const { t } = useTranslation();

  const pbContext = {
    referrer: 'specific-integration',
    i18nData: {
      siteName,
      integrationName: t(integrationName),
    },
  };

  return (
    <CTAWrapper>
      <Button
        as="a"
        href={buildHrefFromRoute(BILLING.path, {
          'pb-context': JSON.stringify(pbContext),
        })}
        kind="primary"
        icon="crown"
        aria-label={t('integrations:details.header.upgrade-to-unlock')}
      >
        {t('integrations:details.header.upgrade-to-unlock')}
      </Button>
    </CTAWrapper>
  );
};
